// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-sports-v2-cards[data-v-f588c56e]{margin-top:30px!important;width:100%;overflow:hidden}@media(max-width:550px){.global-sports-v2-cards[data-v-f588c56e]{padding-inline-start:15px}}", ""]);
// Exports
module.exports = exports;
